EtdActions = require 'actions/etd_actions'
ConclusionsTextSection = require 'components/etd/conclusions_text_section'
{ useCoffeeCallback, useI18n } = require 'lib/react_utils'

RemarksSection = ({
  sectionId,
  editable,
  index,
  renderMode,
  remarks,
  noAutoSave,
  refToEditor,
  stickControlsTo,
  withApplyCancelButtons
}) ->
  i18n = useI18n('es:recommendations.table')

  removeRemarks = useCoffeeCallback [sectionId, index], ->
    EtdActions.removeRemarks { sectionId, index }

  addRemarks = useCoffeeCallback [sectionId, index], ->
    EtdActions.addRemarks { sectionId, index }

  cellId = if sectionId is 'multipleRecommendations'
    "#{sectionId}_#{index}_remarks#conclusionsMultiRecommendations"
  else
    "remarks#conclusions"

  <div className="remarks">
    <div className="remarks__header">
      {if remarks.isEmpty() and renderMode is 'printout'
        null
      else if remarks.isEmpty() and editable
        <h2 className="m-0 text-center">
          <button onClick={addRemarks} className="add-remarks">+ {i18n('/actions.add_remarks')}</button>
        </h2>
      else
        <h2 className="m-0 flex items-center justify-between">
          {i18n('remarks')}
          {editable && <button className="" onClick={removeRemarks}>
            {'\u2a2f'}
          </button>}
        </h2>
      }
    </div>
    <div className="remarks__content">
      {not remarks.isEmpty() && <ConclusionsTextSection
        cellId={cellId}
        content={remarks.get('content', '')}
        editable={editable}
        isConsensus={false}
        refToEditor={refToEditor or null}
        noAutoSave={noAutoSave}
        renderMode={renderMode}
        stickControlsTo={stickControlsTo}
        withApplyCancelButtons={withApplyCancelButtons}
      />}
    </div>
  </div>

RemarksSection.propTypes =
  sectionId: PropTypes.string.isRequired
  editable: PropTypes.bool
  index: PropTypes.number
  renderMode: PropTypes.string
  remarks: PropTypes.instanceOf(Immutable.Map)

RemarksSection.defaultProps =
  editable: true
  remarks: Immutable.Map()
  noAutoSave: false
  withApplyCancelButtons: true

module.exports = RemarksSection

